import type { AIModel, Idea, TrendPreset } from '@repo/shared';

export type { AIModel, Idea, TrendPreset } from '@repo/shared';

export interface TrendsResponse {
  trends: TrendPreset[];
  featured: TrendPreset[];
  categories: string[];
}

const API_URL = process.env.NEXT_PUBLIC_API_URL || '';

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: { code: string; message: string };
}

async function get<T>(path: string): Promise<T> {
  const url = API_URL ? `${API_URL}${path}` : path;
  const response = await fetch(url, {
    headers: { 'Content-Type': 'application/json' },
  });

  const json = (await response.json()) as ApiResponse<T>;
  if (!response.ok || !json.success || json.data === undefined) {
    throw new Error(json.error?.message || `Request failed: ${response.status}`);
  }
  return json.data;
}

export const apiHooks = {
  getModels: () => get<AIModel[]>('/api/models'),
  getIdeas: () => get<Idea[]>('/api/ideas'),
  getTrends: (category?: string) =>
    get<TrendsResponse>(`/api/trends${category ? `?category=${encodeURIComponent(category)}` : ''}`),
  getTrendById: (id: string) => get<TrendPreset>(`/api/trends/${id}`),
};
